module.exports = __webpack_public_path__ + "img/thumbnail_BighornSheep_f_normal.ec2cde57.png";